<template>
	<section class="mainContainer">
		<slot></slot>
	</section>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
@import "~@/scss/libs.scss";

.mainContainer {
	padding: 0 px2rem(20);
}
</style>
